import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Square-White-Logo-with-Cloured-Background.svg';

function NavBar() {
    return (
        <nav id='navBar'>
            <Link to="/"><img src={Logo} alt="logo" /></Link>
            <ul>
                <li><Link to="/" className='link'>Home</Link></li>
                <li><Link to="/products" className='link'>Products</Link></li>
                <li><Link to="/about" className='link'>About Us</Link></li>
                <li><Link to="/contact" className='link'>Contact Us</Link></li>
            </ul>
        </nav>
    );
}
export default NavBar;